import styled from 'styled-components';
import { Error as ErrorBase, Flex as FlexBase } from '../../../style';

export const FieldFlex = styled(FlexBase).attrs({
    align: 'stretch',
    justify: 'flex-start',
    column: true,
    width: '400px',
    maxWidth: '400px',
})`
    margin-bottom: 16px;
`;

export const FirstFieldFlex = styled(FieldFlex)``;

export const Error = styled(ErrorBase).attrs({
    margin: '5px 0 0 0',
})``;

export const SuccessMessage = styled.p`
    color: ${({ theme }) => theme.color.green.main};
    font-size: ${({ theme }) => theme.font.size.small};
    margin: 10px 0 0 0;
`;
